module.exports = __webpack_public_path__ + "static/og_about_luca-a696406385e8d1b465256a30a1517e5e.png";